<main class="tw:pt-20 tw:pl-12 tw:md:pl-20 tw:pr-10">
    <ng-content></ng-content>
</main>
